module.exports = __webpack_public_path__ + "media/images/niq-upload-4d27daad0d091ee55b0a0e38d13f224a.png";